import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { MessageSquare } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

const TeamsNode = ({ data, selected }: NodeProps) => {
    return (
        <BaseNodeUI
            title={data?.label || "Microsoft Teams"}
            icon={MessageSquare}
            colorClass="text-blue-600"
            bgClass="bg-blue-100"
            selected={selected}
            isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            rowsProcessed={data?.rowsAffected}
        />
    );
};

export default memo(TeamsNode);
